import { AxiosError } from 'axios';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams, useNavigate } from 'react-router-dom';
import {
  Header,
  Dimmer,
  Loader,
  Form,
  Button,
  Message,
  Segment,
} from 'semantic-ui/semantic-ui-imports';
import axios from '../../services/request';
import './index.scss';

type ResetPasswordProps = {
  uid: string;
  token: string;
  new_password1: string | undefined;
  new_password2: string | undefined;
};

function SetNewPasswordPage() {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [password1, setPassword1] = React.useState<string | undefined>();
  const [password2, setPassword2] = React.useState<string | undefined>();
  const [errors, setErrors] = React.useState<ResetPasswordProps>();

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { uid, token } = useParams<ResetPasswordProps>();

  React.useEffect(() => {
    setErrors(undefined);
  }, [password1, password2]);

  const onSubmit = async () => {
    setIsLoading(true);

    const params = {
      uid,
      token,
      new_password1: password1,
      new_password2: password2,
    };

    try {
      await axios.post(`/rest-auth/password/reset/confirm/`, params);
      navigate('/login');
      setIsLoading(false);
    } catch (error) {
      const err: AxiosError = error as AxiosError;
      if (err.response) {
        setErrors(err.response?.data);
      }
      setIsLoading(false);
    }
  };

  return (
    <div className="set-new-password-page">
      <Dimmer active={isLoading}>
        <Loader active={isLoading}>{t('verifyEmailPage.loading')}</Loader>
      </Dimmer>
      <Header color="teal" className="set-new-password-page__header">
        {t('setNewPasswordPage.header')}
      </Header>
      <Form className="set-new-password-page__form" onSubmit={onSubmit}>
        <Segment>
          <Form.Input
            name="password1"
            label={t('setNewPasswordPage.password1')}
            fluid
            icon="lock"
            iconPosition="left"
            placeholder={t('setNewPasswordPage.password1')}
            type="password"
            onChange={(e: any, { value }: any) => setPassword1(value)}
            error={errors?.new_password1}
          />
          <Form.Input
            name="password2"
            label={t('setNewPasswordPage.password2')}
            fluid
            icon="lock"
            iconPosition="left"
            placeholder={t('setNewPasswordPage.password2')}
            type="password"
            onChange={(e: any, { value }: any) => setPassword2(value)}
            error={errors?.new_password2}
          />
          <Button
            className="set-new-password-page__button"
            type="submit"
            color="teal"
            fluid
            size="large"
            disabled={isLoading}
            ˇ
            loading={isLoading}
          >
            {t('setNewPasswordPage.buttonText')}
          </Button>
        </Segment>
      </Form>
      <Message warning hidden={!errors?.token} error={!errors?.token}>
        <p>
          {t('setNewPasswordPage.tokenError')} -{' '}
          <Link to="/resetpassword">{t('loginPage.resetPasswordLink')}</Link>
        </p>
      </Message>
    </div>
  );
}

export default SetNewPasswordPage;
